<script>
import {Button} from "@core/components/common";
export default {
    components: {Button}
}
</script>

<template>
    <div class="demo-inline-spacing">
        <Button @click="$emit('save')" class="mt-0">
            {{ $t('Component(Button):save') }}
        </Button>
        <Button @click="$emit('close')" class="mt-0">
            {{ $t('Component(Button):close') }}
        </Button>
    </div>
</template>
